import { createContext } from "react";

import { BillingScreenHelper } from "./BilllingScreenHelper.ts";

export const BillingScreenContext = createContext<BillingScreenHelper>(
  {} as BillingScreenHelper
);
